<template>
  <v-dialog v-model="opened" max-width="800" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? " Tambah" : "Ubah" }} Checkin Member
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <date-picker
                  class="mb-6"
                  placeholder="Tanggal"
                  valueType="format"
                  :format="'YYYY-MM-DD'"
                  v-model="data.checkin_date"
                ></date-picker>
                 <v-autocomplete
                  label="Member"
                  dense
                  outlined
                  v-model="data.member_id"
                  :items="listMembers"
                  item-text="name"
                  item-value="id"
                  :rules="rules.member_id"
                  clearable
                ></v-autocomplete>
                <v-autocomplete
                  label="Personal Trainer"
                  dense
                  outlined
                  v-model="data.personal_trainer_id"
                  :items="listPersonalTrainers"
                  item-text="name"
                  item-value="id"
                  clearable
                ></v-autocomplete>
                <v-text-field
                  v-model="data.start_time"
                  label="Jam Mulai"
                  type="time"
                  dense
                  outlined
                  :rules="rules.start_time"
                ></v-text-field>
                <v-text-field
                  v-if="data.personal_trainer_id"
                  v-model="data.end_time"
                  label="Jam Selesai"
                  type="time"
                  dense
                  outlined
                  :rules="rules.end_time"
                ></v-text-field>
                
               
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" align="end">
              <v-btn
                depressed
                class="ma-1"
                :disabled="loading"
                @click="close()"
              >
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                v-if="canEdit"
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";

export default {
  async mounted() {
    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;
  },
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      listMembers: [],
      listPersonalTrainers: [],
      data: {
        checkin_date: null,
        start_time: null,
        member_id: null,
        personal_trainer_id: null,
        end_time: null,
      },
      rules: {
        checkin_date: [(v) => !!v || "Checkin Date is required"],
        start_time: [(v) => !!v || "Start Time is required"],
        end_time: [(v) => !!v || "End Time is required"],
        member_id: [(v) => !!v || "Member is required"],
      },
    };
  },
  props: {
    module: {
      type: String,
    },
    success: {
      type: Function,
      default: function () {},
    },
  },
  methods: {
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.form.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get("checkin-member?id=" + id)
        .then(({ data }) => {
          this.data = {
            checkin_date: data.checkin_date,
            start_time: data.start_time,
            end_time: data.end_time,
            member_id: data.member_id,
            personal_trainer_id: data.personal_trainer_id,
          };
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "checkin-member";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.$refs.form.reset();
    },
    async fetchPersonalTrainers(memberId) {
      this.loadingData = true;
      try {
        const response = await ApiService.get(
          `reservation-pt/list-personal-trainer?member_id=${memberId}`
        );
        this.listPersonalTrainers = response.data;
      } catch (error) {
        this.handleError(error.response.data);
      } finally {
        this.loadingData = false;
      }
    },
  },
  watch: {
    ["data.name"](value) {
      this.data.slug = value ? slugify(value) : null;
    },
    ["data.member_id"]: function (memberId) {
      if (memberId) {
        this.fetchPersonalTrainers(memberId);
      } else {
        this.listPersonalTrainers = [];
      }
    },
  },
  computed: {
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>
